import React, { useState, useEffect } from "react";
import axios from "axios";
import { faEdit, faEye, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faClipboardList,faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FaClipboardList  } from "react-icons/fa";

const AuditsTable = () => {
  const [audits, setAudits] = useState([]);
  const [editingAudit, setEditingAudit] = useState(null);
  const [formData, setFormData] = useState({ title: "", description: "" });
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);

  const fetchAudits = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get("https://alloaudit.com/api/audits", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAudits(response.data);
    } catch (err) {
      console.error("Error fetching audits:", err);
      MySwal.fire({
        icon: "error",
        title: "Erreur",
        text: "Impossible de charger les audits.",
      });
    }
  };

  useEffect(() => {
    fetchAudits();
  }, []);

  const handleEditClick = (audit) => {
    setEditingAudit(audit.id);
    setFormData({ title: audit.title, description: audit.description || "" });
  };

  const handleCancelEdit = () => {
    setEditingAudit(null);
    setFormData({ title: "", description: "" });
    MySwal.fire({
      icon: "info",
      title: "Modification annulée",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    MySwal.fire({
      title: "Confirmer la mise à jour ?",
      text: "Les changements seront enregistrés.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui, enregistrer",
      cancelButtonText: "Annuler",
      confirmButtonColor: "#2563EB",
      cancelButtonColor: "#6B7280",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const token = localStorage.getItem("token");
          await axios.put(
            `https://alloaudit.com/api/audits/${editingAudit}`,
            formData,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          MySwal.fire({
            icon: "success",
            title: "Audit mis à jour !",
            text: "Les informations ont été enregistrées avec succès.",
            showConfirmButton: false,
            timer: 1800,
          });

          setEditingAudit(null);
          fetchAudits();
        } catch (err) {
          console.error("Erreur lors de la mise à jour:", err);
          MySwal.fire({
            icon: "error",
            title: "Erreur",
            text: "Une erreur s’est produite lors de la mise à jour.",
          });
        }
      }
    });
  };

  const handleView = (auditId) => {
    navigate(`/audits/${auditId}`);
  };

  return (
      <div className="p-4 bg-white shadow-md rounded-lg my-8">
        <h2 className="text-2xl font-bold text-[#1E3A8A] mb-6 flex items-center gap-2">
          <FaClipboardList  className="text-[#10B981]" /> List of Audits
        </h2>
        {editingAudit && (
          <div className="mb-6 border border-blue-200 rounded-lg p-4 bg-blue-50">
            <h2 className="text-lg font-semibold text-blue-900 mb-3">
              Edit audit
            </h2>
            <form onSubmit={handleUpdate} className="space-y-3">
              <div>
                <label className="block font-medium text-gray-700">
                  Title:
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="w-full border rounded-md p-2 focus:ring focus:ring-blue-300"
                />
              </div>
              <div>
                <label className="block font-medium text-gray-700">
                  Description :
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  rows="3"
                  className="w-full border rounded-md p-2 focus:ring focus:ring-blue-300"
                ></textarea>
              </div>
              <div className="flex justify-end space-x-4">
                <button
                  type="button"
                  onClick={handleCancelEdit}
                  className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 flex items-center"
                >
                  <FontAwesomeIcon icon={faTimes} className="mr-2" />
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead className="bg-blue-50 text-blue-900 text-left">
              <tr>
                <th className="py-3 px-4 text-left ">
                   <FontAwesomeIcon icon={faClipboardList} className="text-gray-500 mr-2" />Title
                </th>
                <th className="py-3 px-4 text-left ">
                  <FontAwesomeIcon icon={faInfoCircle} className="text-gray-500 mr-2 mt-1" />Description
                </th>
                <th className="py-3 px-4 text-center ">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {audits.map((audit) => (
                <tr key={audit.id} className="hover:bg-gray-50">
                  <td className="py-3 px-4">{audit.title}</td>
                  <td className="py-3 px-4">{audit.description || "—"}</td>
                  <td className="py-3 px-4 text-center">
                    <div className="inline-flex space-x-4">
                      <button
                        onClick={() => handleEditClick(audit)}
                        className="text-green-600 hover:text-green-800"
                      >
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                      <button
                        onClick={() => handleView(audit.id)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {audits.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center py-6 text-gray-500">
                    No audits found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default AuditsTable;
